import { gql } from '@apollo/client';

export const SEND_MOBILE_VERIFICATION_CODE_MUTATION = gql`
  mutation sendMobileVerificationCode($mobileNumber: String!) {
    sendMobileVerificationCode(data: { mobileNumber: $mobileNumber }) {
      success
      message
      verified
    }
  }
`;

export const VERIFY_MOBILE_VERIFICATION_CODE_MUTATION = gql`
  mutation sendMobileVerificationCode($mobileNumber: String!, $code: String!) {
    verifyMobileCode(data: { mobileNumber: $mobileNumber, code: $code }) {
      success
      message
      verified
    }
  }
`;
